import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles({
  label: {
    overflowWrap: "anywhere"
  }
});
